import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { makeShortLink } from '../../store/actions/shareButtons';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  RedditIcon,
  RedditShareButton,
  TumblrIcon,
  TumblrShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

const ShareSocialMediaPopUpContent = props => {
  const { link } = props;

  const size = 68;
  const shareUrl = link;
  const title = 'Konfiguracja szafy flex';
  const exampleImage = 'react-share-pin-example.png';

  useEffect(() => {
    props.getLink();
    /* eslint-disable-next-line */
  }, []);

  return (
    <div className="pop-up__content">
      <div className="pop-up__content-item">
        <FacebookShareButton
          url={shareUrl}
          quote={title}
          className="facebook-network__share-button">
          <FacebookIcon size={size} round />
        </FacebookShareButton>
        {
          // appIdFacebookMessenger &&
          // <FacebookMessengerShareButton
          //   url={shareUrl}
          //   appId={appIdFacebookMessenger}
          //   className="messanger-network__share-button"
          // >
          //   <FacebookMessengerIcon size={size} round/>
          // </FacebookMessengerShareButton>
        }
        <TwitterShareButton url={shareUrl} title={title} className="twitter-network__share-button">
          <TwitterIcon size={size} round />
        </TwitterShareButton>

        <WhatsappShareButton
          url={shareUrl}
          title={title}
          separator=":: "
          className="wahtapp-network__share-button">
          <WhatsappIcon size={size} round />
        </WhatsappShareButton>

        <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
          <LinkedinIcon size={size} round />
        </LinkedinShareButton>

        <PinterestShareButton
          url={String(window.location)}
          media={`${String(window.location)}/${exampleImage}`}
          className="pinterest-network__share-button">
          <PinterestIcon size={size} round />
        </PinterestShareButton>

        <RedditShareButton
          url={shareUrl}
          title={title}
          windowWidth={660}
          windowHeight={460}
          className="reddit-network__share-button">
          <RedditIcon size={size} round />
        </RedditShareButton>

        <TumblrShareButton url={shareUrl} title={title} className="tumblr-network__share-button">
          <TumblrIcon size={size} round />
        </TumblrShareButton>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.token.token,
    link: state.socialShare.hash || '',
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getLink: () => dispatch(makeShortLink(ownProps.token)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareSocialMediaPopUpContent);
